import axios from "axios";
import { createPinia } from "pinia";
import { createApp } from "vue";
import { useI18n } from "../shared/composables/i18n";
import { useBaseComponents } from "./plugins/base-components";
import { useDecisionTreeStore } from "./store/decision-tree";

import App from "./App.vue";

import "./assets/main.scss";

export const createAppInstance = async (props) => {
  axios.defaults.embedHost = props.host;

  const { i18n } = await useI18n({ key: "decision_tree.viewer" });

  const pinia = createPinia();
  const { reset: resetDecisionTree, setCurrentState, enablePreviewMode, enableDebugMode } = useDecisionTreeStore(pinia);

  const app = createApp(App).use(i18n).use(pinia).use(useBaseComponents());
  resetDecisionTree(props);

  if (props.currentState) {
    setCurrentState(props.currentState);
  }

  if (props.previewMode) {
    enablePreviewMode();
  }

  if (props.debugMode) {
    enableDebugMode();
  }

  return app;
};
